// ページトップ
$(function() {
	var pagetop = $('#page-top');
	pagetop.click(function() {
		$('body, html').animate({
			scrollTop: 0
		}, 500);
		return false;
	});
});

// ページ内リンク（同ページ）
$(function(){
	$('a[href*=\\#]:not([href=\\#])').click(function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var $target = $(this.hash);
			$target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
			$headerHeight = $('.header_content').outerHeight()
			if ($target.length) {
				var targetOffset = $target.offset().top  - $headerHeight;
				$('html,body').animate({scrollTop: targetOffset}, 1000);
			return false;
			}
		}
	});
});

// ページ内リンク（別ページ）
$(function(){
	const hash = location.hash;
	if(hash){
		$("html, body").stop().scrollTop(0);
		setTimeout(function(){
			$target = $(hash)
			$headerHeight = $('.header_content').outerHeight()
			var targetOffset = $target.offset().top - $headerHeight;
			$("html, body").animate({scrollTop: targetOffset}, 1000);
		});
	}
});

// ローディングアニメーション
$(window).on('load',function(){
  $("#splash").delay(1500).fadeOut('slow');
  $("#splash_logo").delay(1200).fadeOut('slow');
});

// フェードアニメーション
$(function() {
	$(window).on('scroll', function () {
		$('.fadeInup').each(function () {
			if ($(window).scrollTop() > ($(this).offset().top - $(window).height() + 100)) {
				$(this).addClass("active");
			}
		});
	}).trigger('scroll');
});

// ヘッダー背景色
$(function () {
  $(window).on("scroll", function () {
    const sliderHeight = $("#mainvisual").height();
    const secTtl = $("#sec_top").height() - 100;
    if (sliderHeight - 30 < $(this).scrollTop() || secTtl - 30 < $(this).scrollTop()) {
      $(".header_content").addClass("bk");
	  $(".zdo_drawer_menu").addClass("bk");
    } else {
      $(".header_content").removeClass("bk");
	  $(".zdo_drawer_menu").removeClass("bk");
    }
  });
});

// 商品詳細スライダー
const product_thumb = new Swiper('.p_single-slider-sub', {
  slidesPerView: 4,
  spaceBetween: 12,
  loop: true,
});

const product_main = new Swiper('.p_single-slider-main', {
	effect: 'fade',
	fadeEffect: {
		crossFade: true,
	},
	speed: 500,
	navigation: {
		nextEl: '.p_single-slider-inner .swiper-button-next',
		prevEl: '.p_single-slider-inner .swiper-button-prev',
	},
	thumbs: {
		swiper: product_thumb,
	},
});

// 商品詳細アコーディオン
$('.title').on('click', function() {
	var findElm = $(this).next(".box");
	$(findElm).slideToggle();
		
	if($(this).hasClass('close')){
		$(this).removeClass('close');
	}else{
		$(this).addClass('close');
	}
});

const mainvisualSlider = new Swiper('.mainvisual_slider', {
 	loop: true,
	effect: 'fade',
	fadeEffect: {
	crossFade: true,
	},
	autoplay: {
	delay: 6000,
	disableOnInteraction: false,
	},
	speed: 2000,
});


const header = document.querySelector('.header_content');
const announcementBar = document.querySelector('.announcement-bar');
const mobileMenu = document.querySelector('.zdo_drawer_button'); // クラス名は実際のものに変えて

function getBarHeight() {
  return announcementBar ? announcementBar.offsetHeight : 0;
}

function updateHeaderTop() {
  const barHeight = getBarHeight();
  const scrollY = window.scrollY;
  const offset = Math.max(0, barHeight - scrollY);
  header.style.top = offset + 'px';
}

function updateMobileMenuTop() {
  const barHeight = getBarHeight();
  const scrollY = window.scrollY;
  const offset = Math.max(0, barHeight - scrollY);
  // 元々の21px + 告知バーのオフセット
  mobileMenu.style.top = (31 + offset) + 'px';
}

function updateAll() {
  updateHeaderTop();
  updateMobileMenuTop();
}

window.addEventListener('scroll', updateAll);
window.addEventListener('resize', updateAll);
updateAll(); // 初期化